import React from 'react';

const CloseIcon = ({
  ariaHidden = false,
  color = 'currentColor',
  className = '',
  width = '12',
  height = '12',
  customClick = undefined,
}) => (
  <svg
    aria-hidden={ariaHidden}
    className={className}
    width={width}
    height={height}
    onClick={customClick}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.36373 5.96231L11.6067 1.71931C11.8667 1.46824 11.9709 1.09644 11.8794 0.746806C11.7879 0.397176 11.5149 0.124131 11.1652 0.0326158C10.8156 -0.0588996 10.4438 0.0453567 10.1927 0.305313L5.94973 4.54831L1.70773 0.305313C1.45514 0.0525478 1.08689 -0.0462636 0.741695 0.0461003C0.396501 0.138464 0.126803 0.407971 0.0341954 0.7531C-0.0584125 1.09823 0.0401387 1.46655 0.292726 1.71931L4.53573 5.96231L0.292726 10.2053C0.0401387 10.4581 -0.0584125 10.8264 0.0341954 11.1715C0.126803 11.5167 0.396501 11.7862 0.741695 11.8785C1.08689 11.9709 1.45514 11.8721 1.70773 11.6193L5.94973 7.37631L10.1927 11.6193C10.5851 11.9983 11.2088 11.9929 11.5945 11.6071C11.9803 11.2214 11.9857 10.5977 11.6067 10.2053L7.36373 5.96231Z"
      fill={color}
    />
  </svg>
);

export default CloseIcon;
